module.exports = __webpack_public_path__ + "img/lalamove-error.c975b6bd.png";